import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'
import { useTranslation } from 'react-i18next';

function Footer() {
    const {t} = useTranslation();
  return (
    <footer>
      <div>
        <a href="https://github.com/Falco830" target="_blank" rel="noreferrer"><GitHubIcon/></a>
        <a href="https://www.linkedin.com/in/alecmichel/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
      </div>
      <p> {t('footerMessage')}  <a href="https://github.com/yujisatojr/react-portfolio-template" target="_blank" rel="noreferrer">Alec Michel</a> {t('footerWithLove')}</p>
    </footer>
  );
}

export default Footer;